import axios from '@/http/axios/index.js'


export default {
    getList(payload) {
        return axios.get('bonus_reserve/list', { params: payload })
    },
    getClients() {
        return axios.get('bonus_reserve/catalog/clients')
    },
    getWeeks() {
        return axios.get('bonus_reserve/catalog/weeks')
    },
    uploadFile(data) {
        return axios.post('bonus_reserve/upload-transaction', data, {
            headers: { 'Content-Type': 'multipart/form-data' },
            processData: false,
            contentType: false
        })
    }
}